import React, { useEffect, useState } from 'react'
import { FaBriefcaseMedical } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PageHeader from '../../shared/PageHeader'
import EmrDetails from './EmrDetails'
import useFetchData from '../../hooks/UseFetchData'
import { EmrHistoryTableColumns } from '../../constants/EmrContants'
import { EditIcon, EyeIcon } from '../../utils/TableActionIcons'
import CustomPagination from '../../shared/CustomPagination'
import CheckPermission from '../../hooks/useCheckPermission'
import { MdOutlineSick } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { LiaPrescriptionBottleAltSolid } from 'react-icons/lia'
import Prescription from './Prescription'
import { RiFilePaper2Line } from 'react-icons/ri'
import EmrHistoryCardRow from './EmrHistoryCardRow'
import EmrHistoryCardRowSkeleton from './EmrHistoryCardRowSkeleton'

const ReusableModal = React.lazy(() => import('../../shared/ReuseableModal'))

const PatientEMR = () => {
  const { t } = useTranslation()
  const selectedPatientData = useSelector(
    state => state?.auth?.seletedPatientData?.labData
  )
  const [selectedEMRData, setSelectEmrData] = useState(null)
  const [openViewEmrModal, setOpenViewEmrModal] = useState(false)
  const [openViewPrescriptionModal, setOpenViewPrescriptionModal] =
    useState(false)
  const { data, loading, executeFetch } = useFetchData()
  const [payloadData, setPayloadData] = useState({
    page: 1,
    perPage: 10,
    patient_id: selectedPatientData?.patient_id
  })
  const actionsCoumn = {
    body: actionsTemplate,
    header: t('Actions')
  }
  const columns = [...EmrHistoryTableColumns(t), actionsCoumn]

  function actionsTemplate (rowData) {
    return (
      <div className='flex items-center gap-1'>
        <EyeIcon
          iconSize={20}
          onClick={() => {
            setOpenViewEmrModal(true)
            setSelectEmrData(rowData)
          }}
        />

        {rowData?.items?.some(
          it => it?.selected_category === 'medication-codes'
        ) && (
          <LiaPrescriptionBottleAltSolid
            size={22}
            className='text-primary cursor-pointer'
            title='Print Prescription'
            onClick={() => {
              setOpenViewPrescriptionModal(true)
              setSelectEmrData(rowData)
            }}
          />
        )}
        {/* {selectedPatientData?.beneficiary_type?.toLowerCase() ===
                    "insurance" && (
                        <RiFilePaper2Line
                            size={20}
                            className="text-primary cursor-pointer ms-2"
                            title={
                                rowData?.practitioner?.department?.name_en?.toLowerCase() ==
                                    "ophthalmology"
                                    ? "Print OCAF"
                                    : rowData?.practitioner?.department?.name_en?.toLowerCase() ==
                                        "Dentistry"
                                        ? "Print DCAF"
                                        : "Print UCAF"
                            }
                            onClick={() => {
                                setSelectedData(rowData);
                                setShowForm(true);
                            }}
                        />
                    )} */}
      </div>
    )
  }

  const fetchInitialData = async () => {
    await executeFetch('POST', '/emr/getByPatientId', payloadData)
  }

  useEffect(() => {
    fetchInitialData()
  }, [executeFetch, payloadData])

  const onPageChange = async (newPage, newRowsPerPage) => {
    let payload = {
      ...payloadData,
      page: newPage,
      perPage: newRowsPerPage
    }
    setPayloadData(payload)
  }

  return (
    <div className='main-page-container'>
      <PageHeader
        title={t('medical_summary')}
        Icon={FaBriefcaseMedical}
      ></PageHeader>
      <div className='mt-4'>
        {loading ? (
          <EmrHistoryCardRowSkeleton />
        ) : (
          <>
            {data?.data?.length > 0 ? (
              <>
                {data?.data?.map((row, idx) => (
                  <EmrHistoryCardRow
                    key={row.emr_id}
                    row={row}
                    index={idx}
                    actions={actionsTemplate}
                  />
                ))}
                <CustomPagination
                  currentPage={data?.page}
                  rowsPerPage={data?.perPage}
                  totalRecords={data?.totalCount}
                  totalPages={Math.ceil(
                    (data?.totalCount || 0) / (data?.perPage || 1)
                  )}
                  onPageChange={onPageChange}
                  rounded
                  className='mt-3'
                />
              </>
            ) : (
              <div className='flex items-center justify-center py-20 bg-white rounded-lg border border-gray-200'>
                <p className='text-gray-500 text-lg'>{t('No data found')}</p>
              </div>
            )}
          </>
        )}
      </div>
      <ReusableModal
        position='top'
        isVisible={openViewEmrModal}
        title={t('Medical Report')}
        HeaderIcon={FaBriefcaseMedical}
        onClose={() => {
          setOpenViewEmrModal(false)
          setSelectEmrData(null)
        }}
        className='w-full lg:w-[850px] relative'
      >
        <EmrDetails emrData={selectedEMRData} />
      </ReusableModal>

      <ReusableModal
        position='top'
        isVisible={openViewPrescriptionModal}
        title={t('Prescription')}
        HeaderIcon={FaBriefcaseMedical}
        onClose={() => {
          setOpenViewPrescriptionModal(false)
          setSelectEmrData(null)
        }}
        className='w-full lg:w-[850px] relative'
      >
        <Prescription emrData={selectedEMRData} />
      </ReusableModal>
      {/* <ReusableModal
                position="top"
                isVisible={openCreateSickLeaveModal}
                title={t("Create Sick Leave")}
                HeaderIcon={MdOutlineSick}
                onClose={() => {
                    setOpenCreateSickLeaveModal(false);
                    setSelectEmrData(null);
                }}
                className="w-full md:w-[700px] lg:w-[800px] relative "
            >
                <CreateSickLeaveForm
                    emrData={selectedEMRData}
                    patientData={selectedPatientData}
                    setOpenCreateSickLeaveModal={setOpenCreateSickLeaveModal}
                    setSelectEmrData={setSelectEmrData}
                />
            </ReusableModal>
            <CafFormComponent
                selectedData={selectedData}
                setShowForm={setShowForm}
                showForm={showForm}
                edit={true}
                setSelectedData={setSelectedData}
            /> */}
    </div>
  )
}

// export const CafFormComponent = ({
//   selectedData,
//   setShowForm,
//   showForm,
//   setSelectedData,
//   edit = false,
// }) => {
//   if (!selectedData) return null;

//   const dept = selectedData?.practitioner?.department?.name_en?.toLowerCase();

//   if (dept === "ophthalmology") {
//     return (
//       <OcafForm
//         item={selectedData}
//         setShowOcaf={setShowForm}
//         showOcaf={showForm}
//         setSelectedData={setSelectedData}
//         edit={edit}
//       />
//     );
//   } else if (dept === "dentistry" || dept === "dental") {
//     return (
//       <DcafForm
//         item={selectedData}
//         setShowDCAF={setShowForm}
//         showDCAF={showForm}
//         setSelectedData={setSelectedData}
//         edit={edit}
//       />
//     );
//   } else {
//     return (
//       <UcafForm
//         item={selectedData}
//         setShowUCAF={setShowForm}
//         showUCAF={showForm}
//         setSelectedData={setSelectedData}
//         edit={edit}
//       />
//     );
//   }
// };

export default PatientEMR
